import React from "react";
import CategoryPage from "./CategoryPage";

const ITEMS = [
  {
    slug: "time-immersion",
    to: "/percorsi/time-immersion",
    label: "TIME IMMERSION",
    tag: "Percorso",
    desc: "Un'immersione totale nell'ecosistema TIME.",
  },
  {
    slug: "trasfoproduct",
    to: "/percorsi/trasfoproduct",
    label: "TRASFOPRODUCT 6/12 mesi",
    tag: "Percorso",
    desc: "Percorso di trasformazione strutturato su 6 o 12 mesi.",
  },
];

export default function PercorsiPage() {
  return (
    <CategoryPage
      eyebrow="Percorsi"
      title="Camminare nel tempo."
      description="Programmi guidati per trasformare le intenzioni in risultati concreti."
      items={ITEMS}
      testId="percorsi"
      accent="amber"
    />
  );
}
